import React from 'react';
const QUESTIONS = ['What should you check when a circuit won’t operate?', 'Where do you start when voltage is present but the load doesn’t respond?', 'What should you verify when a breaker keeps tripping?', 'What does that meter reading actually suggest?', 'What about an intermittent connection or control fault?'];
export function ProblemSection() {
  return <section className="border-y-4 border-volt bg-white px-4 py-4 sm:py-6" data-id="element-139" data-mp="39hvywhv0pr6e">
      <div className="mx-auto max-w-3xl" data-id="element-140" data-mp="39jyy9si28wns">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-141" data-mp="35gu207okpr7l">
          WHAT IF YOUR ELECTRICAL TROUBLESHOOTING RESOURCES WERE ALREADY READY?
        </h2>
        <p className="mt-1.5 text-[13px] font-bold leading-snug text-carbon sm:text-base" data-id="element-142" data-mp="3egz545mqi3fy">
          You already have the technical knowledge.
        </p>
        <p className="mt-1 text-[13px] font-medium leading-snug text-carbon/80 sm:text-base" data-id="element-143" data-mp="1p2km81yedasd">
          The problem is constantly needing the right information to diagnose the
          fault in front of you.
        </p>

        <ul className="mt-2 grid gap-1 sm:grid-cols-2" data-id="element-144" data-mp="jb0o7dcw56a1">
          {QUESTIONS.map(q => <li key={q} className="rounded-md border-l-4 border-volt bg-tech px-2.5 py-1.5 text-[13px] font-medium leading-snug text-carbon" data-id="element-145" data-mp="ocg8h378v8rd">
              {q}
            </li>)}
        </ul>

        <p className="mt-2 text-[13px] font-medium leading-snug text-carbon/80 sm:text-base" data-id="element-146" data-mp="1244k75dkzv7t">
          Instead of jumping between scattered resources,{' '}
          <strong className="text-navy" data-id="element-147" data-mp="174slcjvixsfr">ELECTRICAL DIAGNOSTIC PRO™</strong> gives
          you an organized library of visual, ready-to-use diagnostic resources
          across 6 essential areas of electrical troubleshooting.
        </p>
        <p className="mt-1.5 text-center font-display text-base uppercase text-navy sm:text-2xl" data-id="element-148" data-mp="3dtfcygthxxvy">
          Trace it. Test it. Diagnose it. Verify it.
        </p>
      </div>
    </section>;
}